import {Text} from '../../1elements'


const SelectContactTypeInstruction = () => {
    return(
        <Text>
            {/*Please select the contact type you want to add a contact to*/}
            {/*by clicking <AddCircleOutlineIcon/> button on the side menu*/}
            Please select a contact type from the side menu
        </Text>
    )
}

export default SelectContactTypeInstruction